<template>
  <div class="party_list_com">
    <div class="list_area">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :max-height="maxHeight"
        @selection-change="handleSelectionChange"
        @row-dblclick="rowDbcilckFn"
        @cell-click="cellClickFn"
        @sort-change="sortChange"
        v-loading="loading"
        :span-method="spanMethod">
        <el-table-column label="序号" type="index" width="50" v-if="indexNum" align="center">
        </el-table-column>
        <el-table-column type="selection" width="55" v-if="check" align="center"> </el-table-column>
        <el-table-column
          v-for="(item, index) in tableCells"
          :key="'it' + index"
          :prop="item.prop"
          :class-name="item.fn ? 'pointer' : ''"
          :label="item.label"
          :sortable="item.sortable"
          :show-overflow-tooltip="item.tooltip"
          align="center"
          v-bind="item">
          <template slot-scope="scope">
            <slot :name="item.prop" :scope="scope">
              <span v-if="!item.todos">
                <span
                  v-if="item.format"
                  :style="item.format(scope.row).style"
                  :title="item.format(scope.row).title"
                  >{{ item.format(scope.row).label }}</span
                >
                <span v-else>{{ scope.row[item.prop] }}</span>
              </span>
              <!-- 操作区，包含按钮 -->
              <span class="push_button" v-else>
                <span v-for="(todoItem, todoIndex) in item.todos" :key="todoIndex">
                  <span
                    v-if="todoItem.labelProp"
                    class="link-btn"
                    v-show="exchangeBtn(todoItem.showBtn, scope)"
                    @click="todoClickFn(todoItem, scope)"
                    >{{ scope.row[todoItem.labelProp] }}</span
                  >
                  <el-button
                    v-else
                    v-show="exchangeBtn(todoItem.showBtn, scope)"
                    size="mini"
                    type="text"
                    @click="todoClickFn(todoItem, scope)"
                    >{{ todoItem.label }}</el-button
                  >
                </span>
              </span>
            </slot>
          </template>
        </el-table-column>

        <el-table-column label="排序" width="100" v-if="sork" align="center">
          <template slot-scope="scope">
            <i
              class="el-icon-top"
              style="font-size: 17px; font-weight: 600"
              @click="sorkTopClick(scope.row)"></i>
            <i
              class="el-icon-bottom"
              style="font-size: 17px; margin-left: 20px; font-weight: 600"
              @click="sorkBottomClick(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="list_footer" v-if="pagination">
      <div class="page_area">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :page-count="total"
          :page-sizes="pages"
          :current-page="pageData.page"
          :page-size="pageData.limit"
          :total="total"
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pages: [5, 10, 20, 30, 40],
      curMultipleSelection: [],
      multipleSelection: [],
      initState: true,
      pageData: {
        pageNum: 1,
        pageSize: 10,
        page: 1,
        size: 10,
      },
    };
  },
  props: {
    pageNum: {
      type: Number,
      default() {
        return 1;
      },
    },
    titlequery: {
      type: Boolean,
      default() {
        return true;
      },
    },
    pagination: {
      type: Boolean,
      default() {
        return true;
      },
    },
    sork: {
      type: Boolean,
      default() {
        return false;
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    indexNum: {
      type: Boolean,
      default() {
        return false;
      },
    },
    check: {
      type: Boolean,
      default() {
        return false;
      },
    },
    toolBtns: {
      type: Array,
      default() {
        return [];
      },
    },
    tableCells: {
      type: Array,
      default() {
        return [];
      },
    },
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    pointerLabels: {
      type: Array,
      default() {
        return [];
      },
    },
    total: {
      type: Number,
      default() {
        return 0;
      },
    },
    maxHeight: {
      type: Number,
      default() {
        return "";
      },
    },
    spanMethod: {
      type: Function,
      default() {
        return () => {
          return {
            rowspan: 1,
            colspan: 1,
          };
        };
      },
    },
  },
  watch: {
    tableData(newVal, oldVal) {
      // console.log(oldVal);
      this.initState = false;
      this.$nextTick(() => {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          for (let j = 0; j < newVal.length; j++) {
            if (JSON.stringify(newVal[j]) == JSON.stringify(this.multipleSelection[i])) {
              this.$refs.multipleTable.toggleRowSelection(newVal[j]);
              break;
            }
          }
        }
        this.curMultipleSelection = [];
        this.initState = true;
      });
    },
    pageNum(newVal, oldVal) {
      // console.log(newVal, oldVal);
      this.pageData.page = newVal;
      this.pageData.pageNum = newVal;
    },
  },
  methods: {
    sorkTopClick(row) {
      this.$emit("sorkTop", row);
    },
    sorkBottomClick(row) {
      this.$emit("sorkBottom", row);
    },
    sortChange(column, prop, order) {
      this.$emit("sortChange", column, prop, order);
    },
    handleSelectionChange(val) {
      this.curMultipleSelection = val;
      if (this.initState) {
        for (let i = 0; i < this.tableData.length; i++) {
          for (let j = 0; j < this.multipleSelection.length; j++) {
            if (this.multipleSelection[j].proposerId == this.tableData[i].proposerId) {
              this.multipleSelection.splice(j, 1);
              break;
            }
          }
        }
        for (let i = 0; i < val.length; i++) {
          this.multipleSelection.push(val[i]);
        }
      }
    },
    sizeChangeHandle(limit) {
      // console.log(limit);
      this.pageData.pageSize = limit;
      this.pageData.size = limit;
      this.$emit("search", this.pageData);
    },
    currentChangeHandle(currentPage) {
      // console.log(currentPage);
      this.pageData.page = currentPage;
      this.pageData.pageNum = currentPage;
      this.$emit("search", this.pageData);
    },
    rowDbcilckFn(row, column, event) {
      this.$emit("rowDbclick", row, column, event);
    },
    cellClickFn(row, column, cell, event) {
      let _tableCellsItem = this.tableCells.filter(item => item.label == column.label)[0];
      _tableCellsItem &&
        this.$parent.$parent[_tableCellsItem.fn] &&
        this.$parent.$parent[_tableCellsItem.fn](row, column, cell, event);
    },
    todoClickFn(todoItem, scope) {
      if (todoItem.label == "删除") {
        this.$confirm("确定删除么？", "提示", {
          type: "warning",
        }).then(() => {
          if (this.$parent.$parent[todoItem.fn]) {
            this.$parent.$parent[todoItem.fn](scope);
          } else if (this.$parent[todoItem.fn]) {
            this.$parent[todoItem.fn](scope);
          } else if (this.$parent.$parent.$parent[todoItem.fn]) {
            this.$parent.$parent.$parent[todoItem.fn](scope);
          } else {
            console.info("方法不存在");
          }
        });
      } else {
        if (this.$parent.$parent[todoItem.fn]) {
          this.$parent.$parent[todoItem.fn](scope);
        } else if (this.$parent[todoItem.fn]) {
          this.$parent[todoItem.fn](scope);
        } else if (this.$parent.$parent.$parent[todoItem.fn]) {
          this.$parent.$parent.$parent[todoItem.fn](scope);
        } else {
          console.info("方法不存在");
        }
      }
    },
    toolClickFn(item) {
      if (item.label == "删除") {
        if (this.multipleSelection.length <= 0) {
          this.$message("请勾选操作项");
          return false;
        }
        this.$confirm("确定删除么？", "提示", {
          type: "warning",
        }).then(() => {
          this.$parent.$parent.$parent.$parent[item.fn](item, this.multipleSelection);
        });
      } else {
        this.$parent.$parent.$parent.$parent[item.fn](item, this.multipleSelection);
      }
    },
    exchangeBtn(itemshowBtn, scope) {
      if (itemshowBtn != undefined && eval(itemshowBtn)) {
        return true;
      } else if (itemshowBtn == undefined) {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.party_list_com {
  // /deep/.el-table__cell{
  // 	color: #2C2E38 !important;
  // }
  // .list_area {
  // 	/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
  // 		border-color: #DC1A36;
  // 	}

  // 	/deep/.el-checkbox__inner:hover {
  // 		border-color: #DC1A36;
  // 	}

  // 	/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
  // 	/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  // 		background-color: #DC1A36;
  // 		border-color: #DC1A36;
  // 	}
  // }

  .list_footer {
    margin-top: 21px;
    margin-right: 20px;
    text-align: right;
  }

  // .page_area {
  // 	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  // 		background-color: #DC1A36;
  // 	}

  // 	/deep/.el-pager li:hover {
  // 		color: #DC1A36;
  // 	}

  // 	/deep/.el-pager li.active {
  // 		color: #fff;
  // 	}
  // }
}

::v-deep .el-button {
  margin-left: 10px;
}
</style>

<style>
.pointer {
  cursor: pointer !important;
}
</style>
